import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FilterList.module.css';
import DataTable from '../../../components/common/DataTable';
import filterImg from '../../../assets/filter/filterImg.svg';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

export default function FilterList() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNext, setHasNext] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState('');

  const fetchFilters = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/admin/new-filter/all?page=${currentPage}&size=5`
      );

      const result = response.data;

      if (result.code === 1) {
        let items = result.data.items;

        if (searchKeyword) {
          items = items.filter((filter) =>
            filter.productName.toLowerCase().includes(searchKeyword.toLowerCase())
          );
        }

        const mapped = items.map((item) => ({
          newArrivalFilterId: item.newArrivalFilterId,
          productName: item.productName,
          image: item.image,
        }));

        setFilters(mapped)
        setCurrentPage(result.data.pagination.currentPage);
        setHasNext(result.data.pagination.hasNext);
      } else {
        console.error('데이터 로딩 실패:', result);
      }
    } catch (err) {
      console.error('API 호출 에러:', err);
    }
  };

  useEffect(() => {
    // const mockData = [
    //   {
    //     id: 1,
    //     thumbnail: filterImg,
    //     title: 'GV80 1세대, JX1 / (2020.01.15~) 에어컨필터',
    //     created_at: '2025-05-19-00:00:00'
    //   },
    //   {
    //     id: 2,
    //     thumbnail: filterImg,
    //     title: 'GV80 1세대, JX1 / (2020.01.15~) 에어컨필터',
    //     created_at: '2025-05-15-00:00:00'
    //   },
    //   {
    //     id: 3,
    //     thumbnail: filterImg,
    //     title: 'GV70 2세대, JX1 / (2020.01.15~) 에어컨필터',
    //     created_at: '2025-05-10-00:00:00'
    //   },
    //   {
    //     id: 4,
    //     thumbnail: filterImg,
    //     title: 'GV80 1세대, JX1 / (2020.01.15~) 에어컨필터',
    //     created_at: '2025-05-05-00:00:00'
    //   },
    //   {
    //     id: 5,
    //     thumbnail: filterImg,
    //     title: 'GV80 1세대, JX1 / (2020.01.15~) 에어컨필터',
    //     created_at: '2025-04-28-00:00:00'
    //   }
    // ];

    // let filteredData = mockData;
    // if (searchKeyword) {
    //   filteredData = mockData.filter(filter =>
    //     filter.title.toLowerCase().includes(searchKeyword.toLowerCase())
    //   );
    // }
    // setFilters(filteredData);
    // setTotalPages(10);
    fetchFilters(currentPage);
  }, [currentPage, searchKeyword]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowClick = (filter) => {
    navigate(`/filters/${filter.newArrivalFilterId}`);
  };

  const handleAddFilter = () => {
    navigate('/filters/create');
  };

  const columns = [
    {
      title: '썸네일',
      dataIndex: 'image',
      width: '150px',
      render: (thumbnail) => (
        <div className={styles.thumbnailContainer}>
          <img
            src={thumbnail}
            alt="필터 썸네일"
            className={styles.thumbnail}
          />
        </div>
      )
    },
    {
      title: '제목',
      dataIndex: 'productName',
      width: '500px'
    },
    {
      title: '상세보기',
      dataIndex: 'newArrivalFilterId',
      width: '100px',
      render: (newArrivalFilterId) => (
        <button
          className={styles.detailButton}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/filters/${newArrivalFilterId}`);
          }}
        >
          상세보기
        </button>
      )
    }
  ];

  // 추가하기 버튼
  const ActionArea = () => (
    <div className={styles.actionArea}>
      <button onClick={handleAddFilter} className={styles.addButton}>
        추가하기 +
      </button>
    </div>
  );

  return (
    <div className={styles.container}>
      <DataTable
        columns={columns}
        data={filters}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        actionButton={<ActionArea />}
      />
    </div>
  );
}